import Vue from "vue";
var SocialSharing = require('vue-social-sharing');
Vue.use(SocialSharing);
//@ts-ignore
import { library } from '@fortawesome/fontawesome-svg-core';
//@ts-ignore
import { fab } from '@fortawesome/free-brands-svg-icons';
//@ts-ignore
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons';
//@ts-ignore
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
//@ts-ignore
library.add(fab, faEllipsisH);
Vue.component('font-awesome-icon', FontAwesomeIcon);
export default Vue.extend({
    name: 'SocialShare',
    data() {
        return {
            dropdownOpen: false,
            // @ts-ignore
            fullUrl: window.location.href
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./src/components/social-share/SocialShare.ts
// module id = null
// module chunks = 